<template>
    <section class="case-wrapper">
        <div class="banner-wrapper">
            <h4>回归本质，创造价值</h4>
        </div>
        <div class="about-main">
            <div class="about-item">
                <h4>简介</h4>
                <p>透透医美于2016年在成都创立，致力于让求美用户不花冤枉钱，找到适合自己的变美方式和整形机构、整形医生。在透透医美的产品里，用户可以通过图文形式分享自己的变美心得，也可以通过机构上传的真实案例，大数据估价系统，了解适合自己变美的方式和机构、医生。</p>
                <ul class="about-item-1">
                    <li>
                        <img src="../assets/about_icon_1.png" />
                        <h5>行业愿景</h5>
                        <span>帮助中小型机构树立品牌</span>
                    </li>
                    <li>
                        <img src="../assets/about_icon_2.png" />
                        <h5>用户价值</h5>
                        <span>不花冤枉钱，取悦自己的美</span>
                    </li>
                    <li>
                        <img src="../assets/about_icon_3.png" />
                        <h5>公司文化</h5>
                        <span>透明、正直、合作、进取</span>
                    </li>
                </ul>
            </div>
            <div class="about-item">
                <h4>联系我们</h4>
                <div class="about-item-2">
                    <ul>
                        <li>
                            <label for="">地址</label>
                            <span>四川省成都市高新区天府软件园B区7栋413号</span>
                        </li>
                        <li class="about-item-li">
                            <div>
                                <label for="">电话</label>
                                <span>028-865567788</span>
                            </div>
                            <div>
                                <label for="">商务邮箱</label>
                                <span>work@toutouapp.cn</span>
                            </div>
                        </li>
                        <li class="about-item-li">
                            <div>
                                <label for="">微博</label>
                                <a target="_blank" href="https://weibo.com/u/5872591335?topnav=1&wvr=6&topsug=1">
                                    <img class="m-hidden" src="../assets/weibo.png" alt="">
                                </a>
                                <a class="m-show" href="https://weibo.com/u/5872591335?topnav=1&wvr=6&topsug=1">透透医美 ></a>
                            </div>
                            <div>
                                <label for="">微信</label>
                                <img class="m-hidden" src="../assets/weixin_qr.png" alt="">
                                <a class="m-show" href="">公众号：透透</a>
                            </div>
                        </li>
                    </ul>
                    <!-- <div class="map-wrapper"> -->
                    <a target="_blank" class="map-wrapper" href='https://map.baidu.com/search/四川省成都市高新区天府软件园b区7栋413号/@11585897.095,3552825.74,19z?querytype=s&da_src=shareurl&wd=四川省成都市高新区天府软件园b区7栋413号&c=75&src=0&pn=0&sug=0&l=13&b=(11558549,3520722;11619989,3551730)&from=webmap&biz_forward=%7B"scaler":1,"styles":"pl"%7D&device_ratio=1'>
                        <img class="map-img" src="../assets/map.png" />
                        <img class="map-marker" src="../assets/marker.png" />
                    </a>
                    </div>
                </div>
                <div class="about-item" style="margin-top: 128px;">
                <h4>发展历程</h4>
                <div class="about-item-3">
                    <ul>
                        <li>
                            <h5>2019</h5>
                            <div>
                                <label for="">9月</label>
                                <i></i>
                                <span>全新产品2.0版本发布，累计全国合作机构逾千家</span>
                            </div>
                        </li>
                        <li>
                            <h5>2018</h5>
                            <div>
                                <label for="">8月</label>
                                <i></i>
                                <span>合作全国300多家医疗机构</span>
                            </div>
                        </li>
                        <li>
                            <h5>2017</h5>
                            <div>
                                <label for="">12月</label>
                                <i></i>
                                <span>开展全国线上业务</span>
                            </div>
                            <div>
                                <label for="">7月</label>
                                <i></i>
                                <span>入驻四川省成都市天府软件园</span>
                            </div>
                        </li>
                        <li>
                            <h5>2016</h5>
                            <div>
                                <label for="">9月</label>
                                <i></i>
                                <span>透透医美第一个移动端产品上架各大应用市场</span>
                            </div>
                            <div>
                                <label for="">3月</label>
                                <i></i>
                                <span>组建团队，透透医美正式诞生</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            
        </div>
    </section>
</template>
<script>
// import Vue from 'vue'
// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, { ak: 'lHE6mnVED5uoYvmGDNwSgf3YZNMgxfjL' })

export default {
    
}
</script>

<style lang="less">
.m-show {
    display: none;
}
.case-wrapper {
    padding-top: 78px;
    background:rgba(247,247,247,1);
    .banner-wrapper {
        background: url(../assets/banner.png) no-repeat center center;
        background-size: cover;
        height: 339px;
        position: relative;
        h4 {
            position: absolute;
            color: #fff;
            font-size:24px;
            bottom: 64px;
            left: 50%;
            transform: translateX(-50%);
            letter-spacing: 5px;
        }
    }
}
.about-main {
    position: relative;
    top: -45px;
    width: 1000px;
    margin: 0 auto;
    padding: 32px;
    background: #fff;
    h4 {
        font-size: 29px;
        color: #1A1A1A;
        text-align: center;
        margin-bottom: 27px;
        &::before {
            content: '';
            display: block;
            width: 60px;
            border: 1px solid rgba(26,26,26,0.25);
            margin: 0 auto 10px;
        }
    }
    p {
        color: #333;
    }
    .about-item-1 {
        display: flex;
        justify-content: space-around;
        padding: 65px 0 128px;
        text-align: center;
        img {
            width: 27px;
            height: 32px;
            object-fit: contain;
        }
        h5 {
            font-size: 18px;
            margin: 12px 0 21px;
            color: #000000;
            font-weight:400;
        }
        span {
            color: rgba(0,0,0,0.45); 
        }
    }
    .about-item-2 {
        display: flex;
        justify-content: space-between;
        .map-wrapper {
            display: block;
            width: 405px;
            position: relative;
            .map-img {
                width: 100%;
            }
            .map-marker {
                position: absolute;
                width: 28px;
                left: 220px;
                top: 192px;
            }
        }
        li {
            margin-bottom: 34px;
        }
        label {
            display: block;
            color: #333333;
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 12px;
        }
        span {
            display: block;
            color:rgba(0,0,0,0.45);
        }
        .about-item-li {
            display: flex;
            &>div{
                width: 50%;
            }
            img {
                width: 90px;
            }
        }
    }
    .about-item-3 {
        h5 {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 34px;
        }
        li {
            > div {
                display: flex;
                align-items: center;
                padding-bottom: 52px;
                position: relative;
                &::after {
                    content: '';
                    display: block;
                    height: 32px;
                    width: 1px;
                    background: #D8D8D8;
                    position: absolute;
                    top: 35px;
                    left: 49px;
                }
                &:last-child::after {
                    display: none;
                }
                label {
                    margin-right: 12px;
                    font-size: 16px;
                    color:rgba(0,0,0,0.65);
                    font-weight:500;
                    display: inline-block;
                    width: 35px;
                }
                i {
                    width: 5px;
                    height: 5px;
                    background: #D8D8D8;
                    border-radius: 50%;
                    margin-right: 12px;
                }
                span {
                    color:rgba(0,0,0,0.65);
                }
            }
        }
        
    }
    
}
@media (max-width: 710px) {
    .case-tab-wrapper {
        display: none;
    }
    .m-tab-wrapper {
        display: block;
    }
    .about-main {
        width: 100%;
        top: 0;
    }
    .case-wrapper {
        padding-top: 68px;
        .banner-wrapper {
            background-size: cover;
            height: 120px;
            h4 {
                font-size:15px;
                bottom: 32px;
                // left: 50%;
                // transform: translateX(-50%);
                // letter-spacing: 5px;
            }
        }
    }
    .about-main {
        h4 {
            font-size: 19px;
            text-align: left;
            margin-bottom: 18px;
            &::before {
                content: '';
                display: none;
            }
        }
    }
    .about-item-1 {
        span {
            font-size: 12px;
            display: block;
            padding: 0 5px;
        }
    }
    .about-main {
        .about-item-2 {
            display: block !important;
            .map-wrapper {
                width: 350px;
                position: relative;
                left: -16px;
                .map-img {
                    width: 100%;
                }
                .map-marker {
                    position: absolute;
                    width: 28px;
                    left: 188px;
                    top: 172px;
                }
            }
            .map-img {
                width: 100%;
            }
        }
    }
    .m-hidden {
        display: none;
    }
    .m-show {
        display: block;
    }
    .about-item-li {
        a {
            color:rgba(0,0,0,0.45);
            font-size: 12px;
        }
    }
}
</style>
